









































import { defineComponent, PropType } from '@vue/composition-api'

/**
 * 年度選択コンポーネント
 */
export default defineComponent({
  name: 'AtomSelectYear',
  props: {
    /**
     * 年度データ
     */
    currentYear: {
      type: Number,
      required: true,
    },
    /**
     * 選択年度
     */
    yearList: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  data() {
    return {
      year: this.currentYear,
      isOpenOption: false,
    }
  },
  methods: {
    change(item: number) {
      /**
       * 年度を選択されたことを通知する
       * @event change
       * @type {Object}
       */
      this.$emit('change', item)
      this.isOpenOption = false
    },
    handleCurrentClick() {
      this.isOpenOption = !this.isOpenOption
    },
  },
  watch: {
    currentYear(value) {
      this.year = value
    },
  },
})
